import  * as requests from '../requests'
// 统一数字格式化
export let numberUnify = data => {
  if (data) {
    return data.toLocaleString()
  } else {
    return data
  }
}

// 字符串大写
export let stringUpperCase = value => {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
}

//根据传入时间字符串计算时间
export let calculateTimeTransition = value => {
  if (!value) return 0
  let time = new Date().getTime();
  let lastTime = Date.parse(value);
  return Math.ceil((time - lastTime) / (1000 * 60 * 60 * 24))
}

//根据传入时间字符串计算时间
export let valueName = (value, flag) => {
  let typeLib, _name = {};
  if (/\./.test(flag)) {
    flag = flag.split(".");
    typeLib = requests.CONSTANTS;

    for (let i = 0; i < flag.length; i++) {
      typeLib = typeLib[flag[i]];
    }

  } else {
    typeLib = requests.CONSTANTS[flag]
  }

  for (let i in typeLib) {
    if (typeLib[i].value === value || typeLib[i].value === +value) {
      _name = typeLib[i];
    }
  }

  if (_name['name']) {
    return _name['name'];
  } else {
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/utils/filters.js